import gridComponentBase from "@/components/grid/gridComponentBase.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { TextValueItem } from "@/models/TextValueItem";
import api from "@/services/api";
import { StatiItem } from "@/models/amministrazione/stati/statiItem";
import permessi from "@/config/permessi";

const _ENDPONT_ASSOCIATI = api.endpoint.POLIZZE.POLIZZE_STATI_ASSOCIATi;
const _ENDPONT_DA_ASSOCIARE = api.endpoint.POLIZZE.POLIZZE_STATI_DA_ASSOCIATi;
@Component({})
export default class AssociazioneStatiPolizza extends gridComponentBase {
	get PERMESSI(): string[] {
		return [permessi.BK.Prodotti.POLIZZE];
	}
	@Prop({ default: () => null }) prodottoID: number;
	@Prop({ default: () => null }) gruppoStatoItemId: number;
	@Prop({ default: () => false }) associa: boolean;

	editItem: StatiItem = new StatiItem();
	showEditModal: boolean = false;
	editSubTitle: string = "";
	editTitle: string = "";
	kendop: any = kendo;

	showOnlyActive: boolean = false;

	get columns(): Array<any> {
		return [
			{ field: "itemID", title: "ID", width: 20, filterable: false, hidden: true, headerCell: "myHeaderCellTemplate", editHide: true },
			{ field: "nazione", title: this.$i18n.t("generico.nazione").toString(), headerCell: "myHeaderCellTemplate" },
			{ field: "codiceStatoA3", title: this.$i18n.t("generico.alphaCode3").toString(), groupable: true, headerCell: "myHeaderCellTemplate", export: true, width: 200 },
			// { field: "numerico", title: this.$i18n.t("generico.numerico").toString(), filterType: "numeric-int", groupable: true, headerCell: "myHeaderCellTemplate", export: true, width: 200 },
			// { field: "alphaCode2", title: this.$i18n.t("generico.alphaCode2").toString(), groupable: true, headerCell: "myHeaderCellTemplate", export: true, width: 200 },

			{ field: "_ck_select", title: " ", width: 50, cell: "defaultCellTemplate", type: "ck_select", filterable: false, headerCell: "myHeaderCellTemplate", headerType: "boolean" }
		];
	}

	sort: any = [{ field: "nazione", dir: "asc" }];

	created() {
		var self = this;
		this.take = 20;
		this.pageable.pageSize = 20;
		this.pageSize = 20;
		if (this.group) {
			this.group.map(group => (group.aggregates = this.aggregates));
		}
		this.group = this.group;

		Promise.all([])
			.then(responses => {
				self.getData();
			})
			.catch(err => {
				console.log(err);
			});
	}

	getData() {
		if (this.associa) {
			this.getGridData(`${_ENDPONT_DA_ASSOCIARE}/${this.prodottoID}/${this.gruppoStatoItemId}`);
		} else {
			this.getGridData(`${_ENDPONT_ASSOCIATI}/${this.prodottoID}/${this.gruppoStatoItemId}`);
		}
	}

	associaStati() {
		var self = this;
		if (this.gridData && this.gridData.data && this.gridData.data.length > 0) {
			let stati = this.gridData.data
				.filter(function(item) {
					return item._ck_select == true;
				})
				.map(function(el) {
					return el.itemID;
				});
			if (stati.length) {
				let data = {
					associa: this.associa,
					statiIds: stati
				};
				api.associaPolizzeGruppoStati_Stati(this.prodottoID, this.gruppoStatoItemId, data)
					.then(res => {
						self.$bvToast.toast(self.$i18n.t("generico.cmdeseguito").toString(), {
							variant: "success",
							title: self.$i18n.t("generico.azioneeseguita").toString(),
							solid: true
						});
						self.$emit("reload-associazione-stati");
					})
					.catch(err => {
						console.log(err);
					});
			} else {
				this.$bvToast.toast(this.$i18n.t("generico.noElementsSelected").toString(), {
					variant: "warning",
					title: this.$i18n.t("generico.warning").toString(),
					solid: true
				});
			}
		} else {
			this.$bvToast.toast(this.$i18n.t("generico.nodataforactions").toString(), {
				variant: "warning",
				title: this.$i18n.t("generico.warning").toString(),
				solid: true
			});
		}
	}

	disassociaStati() {
		var self = this;
		if (this.gridData && this.gridData.data && this.gridData.data.length > 0) {
			let stati = this.gridData.data
				.filter(function(item) {
					return item._ck_select == true;
				})
				.map(function(el) {
					return el.itemID;
				});
			if (stati.length) {
				let data = {
					associa: this.associa,
					statiIds: stati
				};
				api.associaPolizzeGruppoStati_Stati(this.prodottoID, this.gruppoStatoItemId, data)
					.then(res => {
						self.$bvToast.toast(self.$i18n.t("generico.cmdeseguito").toString(), {
							variant: "success",
							title: self.$i18n.t("generico.azioneeseguita").toString(),
							solid: true
						});
						self.$emit("reload-associazione-stati");
					})
					.catch(err => {
						console.log(err);
					});
			} else {
				this.$bvToast.toast(this.$i18n.t("generico.noElementsSelected").toString(), {
					variant: "warning",
					title: this.$i18n.t("generico.warning").toString(),
					solid: true
				});
			}
		} else {
			this.$bvToast.toast(this.$i18n.t("generico.nodataforactions").toString(), {
				variant: "warning",
				title: this.$i18n.t("generico.warning").toString(),
				solid: true
			});
		}
	}
}
